var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.324975 6.00039C0.324975 5.88372 0.345975 5.77139 0.387975 5.66339C0.429308 5.55472 0.491641 5.45872 0.574975 5.37539L5.07498 0.875391C5.22497 0.725391 5.39998 0.650391 5.59998 0.650391C5.79998 0.650391 5.97498 0.725391 6.12498 0.875391C6.27498 1.02539 6.34998 1.20039 6.34998 1.40039C6.34998 1.60039 6.27498 1.77539 6.12498 1.92539L2.04998 6.00039L6.12498 10.0754C6.27498 10.2254 6.34998 10.4004 6.34998 10.6004C6.34998 10.8004 6.27498 10.9754 6.12498 11.1254C5.97498 11.2754 5.79998 11.3504 5.59998 11.3504C5.39998 11.3504 5.22497 11.2754 5.07497 11.1254L0.574975 6.62539C0.491641 6.54206 0.429308 6.44639 0.387975 6.33839C0.345975 6.22972 0.324975 6.11706 0.324975 6.00039Z",
    fill: "#4D4184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.43b7d0a1cf1ba95d352a59339ede5c95.svg";
export { ForwardRef as ReactComponent };